const escapeHTML = (value) =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const BIKE_COLORS = {
  negro: "#000000",
  black: "#000000",
  blanco: "#ffffff",
  white: "#ffffff",
  rojo: "#ff0000",
  red: "#ff0000",
  azul: "#0000ff",
  blue: "#0000ff",
  verde: "#008000",
  green: "#008000",
  amarillo: "#ffff00",
  yellow: "#ffff00",
  gris: "#808080",
  gray: "#808080",
  grey: "#808080",
  plateado: "#c0c0c0",
  silver: "#c0c0c0",
  naranja: "#ffa500",
  orange: "#ffa500",
  morado: "#800080",
  purple: "#800080",
  rosado: "#ffc0cb",
  rosa: "#ffc0cb",
  pink: "#ffc0cb",
  marron: "#a52a2a",
  brown: "#a52a2a",
  cafe: "#a52a2a",
  dorado: "#ffd700",
  gold: "#ffd700",
};

const safeBikeColor = (color) => {
  const value = String(color || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  if (/^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/.test(value)) return value;
  return Object.prototype.hasOwnProperty.call(BIKE_COLORS, value) ? BIKE_COLORS[value] : "#e0e0e0";
};

// Solo se interpolan datos escapados y valores de estilo/imagen permitidos.
export const buildBikePrintHTML = ({
  formData = {},
  modo,
  fotos = {},
  ganchoId,
  numeroRegistro,
  qrImageSrc = "",
}) => {
  const fecha = new Date().toLocaleString("es-CO", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
  const qrImgHTML = /^data:image\/png;base64,[A-Za-z0-9+/]+={0,2}$/.test(qrImageSrc)
    ? `<img src="${escapeHTML(qrImageSrc)}" alt="QR" class="qr-img" />`
    : '<div class="qr-placeholder">QR</div>';
  const colorHex = safeBikeColor(formData.color);
  const modoLabel = modo === "INGRESO" ? "INGRESO" : "SALIDA";
  const modoColor = modo === "INGRESO" ? "#2e7d32" : "#c62828";
  const estadoLabel = modo === "INGRESO" ? "OCUPADO" : "DISPONIBLE";
  const estadoBg = modo === "INGRESO" ? "#ffebee" : "#e8f5e9";
  const estadoColor = modo === "INGRESO" ? "#c62828" : "#2e7d32";

  const fotosBadges = [];
  if (fotos.cedula?.tomada) fotosBadges.push("✓ Cédula");
  if (fotos.bicicleta?.tomada) fotosBadges.push("✓ Bicicleta");
  if (fotos.usuario?.tomada) fotosBadges.push("✓ Usuario");

  const fotosHTML =
    fotosBadges.length > 0
      ? fotosBadges.map((b) => `<span class="badge-green">${b}</span>`).join(" ")
      : `<span class="text-muted">Sin fotos</span>`;

  return `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Ticket ISERRA 100</title>
          <meta charset="UTF-8">
          <meta http-equiv="Content-Security-Policy" content="default-src 'none'; style-src 'unsafe-inline'; img-src data:">
          <style>
            * { margin: 0; padding: 0; box-sizing: border-box; }
            @page { margin: 0; size: 80mm auto; }
            body {
              font-family: 'Courier New', 'Consolas', monospace;
              width: 76mm;
              background: #fff;
              color: #000;
              padding: 4mm 2mm;
              font-size: 11px;
              line-height: 1.35;
            }
            .header { text-align: center; padding-bottom: 6px; border-bottom: 1.5px solid #1a237e; margin-bottom: 8px; }
            .header .title { color: #1a237e; font-size: 20px; font-weight: bold; letter-spacing: 3px; margin-bottom: 2px; }
            .header .subtitle { font-size: 10px; letter-spacing: 2px; color: #333; font-weight: bold; }
            .header .desc { font-size: 9px; color: #555; letter-spacing: 0.5px; }
            .info-row { display: flex; justify-content: space-between; font-size: 9.5px; padding: 1.5px 0; }
            .info-row .label { color: #555; font-weight: bold; }
            .info-row .value { text-align: right; font-weight: bold; max-width: 60%; word-break: break-word; }
            .divider { border-top: 1px solid #ccc; margin: 6px 0; }
            .modo-title { text-align: center; color: ${modoColor}; font-size: 18px; font-weight: bold; letter-spacing: 3px; margin: 8px 0 4px 0; }
            .registro { text-align: center; font-size: 10px; font-weight: bold; color: #333; letter-spacing: 1px; }
            .fecha { text-align: center; font-size: 9px; color: #666; margin-bottom: 8px; }
            .qr-box { text-align: center; padding: 6px; background: #fafafa; border: 1px dashed #ccc; border-radius: 4px; margin: 8px 0; }
            .qr-img { width: 42mm; height: 42mm; display: block; margin: 0 auto; }
            .qr-placeholder { width: 42mm; height: 42mm; display: flex; align-items: center; justify-content: center; background: #eee; margin: 0 auto; font-size: 20px; color: #999; }
            .qr-hint { font-size: 8px; color: #666; margin-top: 3px; }
            .section-title { text-align: center; color: #1a237e; font-size: 10.5px; font-weight: bold; letter-spacing: 1px; margin: 8px 0 4px 0; }
            .data-row { display: flex; justify-content: space-between; padding: 1.5px 0; font-size: 10px; }
            .data-row .label { color: #444; font-weight: bold; }
            .data-row .value { font-weight: bold; text-align: right; max-width: 60%; word-break: break-word; }
            .color-dot { display: inline-block; width: 9px; height: 9px; border-radius: 50%; background: ${colorHex}; border: 1px solid #999; vertical-align: middle; margin-right: 4px; }
            .badge-green { display: inline-block; background: #e8f5e9; color: #2e7d32; font-size: 8px; font-weight: bold; padding: 2px 6px; border-radius: 8px; margin-right: 3px; }
            .badge-estado { display: inline-block; background: ${estadoBg}; color: ${estadoColor}; font-size: 8px; font-weight: bold; padding: 2px 8px; border-radius: 8px; }
            .footer { text-align: center; margin-top: 8px; padding-top: 6px; border-top: 1.5px solid #1a237e; }
            .footer .thanks { color: #1a237e; font-size: 10px; font-weight: bold; letter-spacing: 0.5px; }
            .footer .note { font-size: 8px; color: #666; margin-top: 2px; line-height: 1.4; }
            .footer .firma { font-size: 7px; color: #64748b; letter-spacing: 1px; margin-top: 6px; padding-top: 4px; border-top: 1px solid #1a237e; }
            .text-muted { color: #999; }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="title">ISERRA 100</div>
            <div class="subtitle">CENTRO COMERCIAL</div>
            <div class="desc">Control de Bicicletas</div>
          </div>

          <div class="info-row">
            <span class="label">RAZON SOCIAL:</span>
            <span class="value">CENTRO COMERCIAL ISERRA 100 PH</span>
          </div>
          <div class="info-row">
            <span class="label">NIT:</span>
            <span class="value">830.019.348-2</span>
          </div>
          <div class="info-row">
            <span class="label">#ID MAQUINA:</span>
            <span class="value">ISERRA 100</span>
          </div>

          <div class="divider"></div>

          <div class="modo-title">${modoLabel}</div>
          <div class="registro">REGISTRO #${escapeHTML(
            String(numeroRegistro || "000000").padStart(6, "0")
          )}</div>
          <div class="fecha">${fecha}</div>

          <div class="qr-box">
            ${qrImgHTML}
            <div class="qr-hint">Escanea para ver los detalles</div>
          </div>

          <div class="section-title">DATOS DEL USUARIO</div>
          <div class="divider"></div>
          <div class="data-row">
            <span class="label">Nombre:</span>
            <span class="value">${escapeHTML(formData.nombre || "")} ${escapeHTML(
    formData.apellido || ""
  )}</span>
          </div>
          <div class="data-row">
            <span class="label">Cédula:</span>
            <span class="value">${escapeHTML(formData.cedula || "—")}</span>
          </div>
          <div class="data-row">
            <span class="label">Celular:</span>
            <span class="value">${escapeHTML(formData.celular || "—")}</span>
          </div>

          <div class="section-title">DATOS DE LA BICICLETA</div>
          <div class="divider"></div>
          <div class="data-row">
            <span class="label">Color:</span>
            <span class="value"><span class="color-dot"></span>${escapeHTML(
              formData.color || "—"
            )}</span>
          </div>
          <div class="data-row">
            <span class="label">Serie:</span>
            <span class="value">${escapeHTML(formData.serie || "—")}</span>
          </div>

          <div class="section-title">GANCHO</div>
          <div class="divider"></div>
          <div class="data-row">
            <span class="label">Número:</span>
            <span class="value">#${escapeHTML(String(ganchoId || "").padStart(2, "0"))}</span>
          </div>
          <div class="data-row">
            <span class="label">Estado:</span>
            <span class="value"><span class="badge-estado">${estadoLabel}</span></span>
          </div>

          <div class="section-title">FOTOS TOMADAS</div>
          <div class="divider"></div>
          <div class="data-row">
            <span class="label">Estado:</span>
            <span class="value">${fotosHTML}</span>
          </div>

          <div class="footer">
            <div class="thanks">¡Gracias por usar nuestro servicio!</div>
            <div class="note">Este recibo es válido para retirar la bicicleta.</div>
            <div class="note">Presenta este recibo en la entrada.</div>
            <div class="firma">ISERRA 100 - ISERRA 100</div>
          </div>
        </body>
      </html>
    `;
};
